<template>
<div>
  <btn type="primary" @click="importSheets">3 fichiers génériques</btn>
  <modal v-model="show"
         :header="false"
         :backdrop="false"
         :footer="false">
    <h2>Import Réa Inf ADI  - 3 fichiers</h2>
    <div class="row">
      <div class="col-xs-12">
        <p>
          <input ref="fileInput" type="file" single>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <steps :steps="iterator.steps" :stepStates="iterator.stepStates"></steps>
      </div>
    </div>
    <div v-if="completed">
      <btn @click="hide" type="default">Retour</btn>
    </div>
  </modal>
</div>
</template>
<script>
import StepIterator from '@/sui/tools/stepiterator'
import steps from '@/sui/components/steps'
import baseSteps from '@/components/sheets/import/impl/steps'
import impl from '@/components/sheets/import/impl/reainfadi'
import validator from '@/sui/components/sheet/validate/impl/validator'
import types from '@/sui/data/modules'
import assert from '@/sui/tools/assert'

export default {
  name: 'sheets-import-reainfadi3',
  props: {
    surveillance: {
      type: Object,
      required: true
    }
  },

  data: function () {
    const steps = [
      baseSteps.load(
        'Fichier Patient', 'Impossible de charger le fichier patient'
      ),
      baseSteps.transform(
        'Ajout des patients', 'Impossible de traiter le fichier patient',
        (count) => `${count} patients ajoutés avec succès.`,
        (vm, data, o, start, end) => {
          if (start === 0) {
            data.sheets = {}
            vm.d = []
            const module = types.get(this.surveillance.year)['reaInfADI']
            assert.notNull(
              module,
              `selectReference: invalid sheet type (${this.module})`
            )
            vm.reference = module.sheets.edit
          }

          const errors = []
          for (let i = start; i !== end; ++i) {
            const sheet = o[i]
            const p = impl.createPatient(this.surveillance.year, sheet)
            const number = p.sheetNumber
            if (number == null) {
              errors.push(`patient ${i}, missing sheet number: ${number}`)
              continue
            }
            p.bmrBhreMicroOrgs = impl.createBmrBHre(sheet)
            data.sheets[number] = p
          }
          if (errors.length > 0) {
            throw new Error(errors.join('<br />'))
          }
        }
      ),
      baseSteps.load(
        'Fichier CVC', 'Impossible de charger le fichier CVC'
      ),
      baseSteps.transform(
        'Ajout des CVCs', 'Impossible de traiter le fichier CVC',
        (count) => `${count} CVCs ajoutés avec succès.`,
        (vm, data, o, start, end) => {
          const errors = []
          for (let i = start; i !== end; ++i) {
            const number = o[i].sheetNumber
            if (data.sheets[number] == null) {
              errors.push(`cvc ${i}: invalid sheet number ${number}`)
              continue
            }
            const transformed = impl.createCatheter(o[i])
            data.sheets[number].catheters.push(transformed)
          }

          if (errors.length > 0) {
            throw new Error(errors.join('<br />'))
          }
        }
      ),
      baseSteps.load(
        'Fichier infections', 'Impossible de charger le fichier infections'
      ),
      baseSteps.transform(
        'Ajout des infections', 'Impossible de traiter le fichier infections',
        (count) => `${count} infections ajoutées avec succès.`,
        (vm, data, o, start, end) => {
          const errors = []
          for (let p = start; p !== end; ++p) {
            const i = o[p]
            const number = i.sheetNumber
            const sh = data.sheets[number]
            if (sh == null) {
              errors.push(`infection ${i}: invalid sheet number ${number}`)
              continue
            }

            if (i.type === 2) {
              const transformed = impl.createBacteremia(i)
              sh.bacteriemia = 1
              sh.bacteremias.push(transformed)
            } else if (i.type === 1) {
              const transformed = impl.createPneumopathy(i)
              sh.pneumopathy = 1
              sh.pneumopathies.push(transformed)
            } else {
              errors.push(`infection ${p}: invalid infection type ${i}`)
            }
          }

          if (errors.length > 0) {
            throw new Error(errors.join('<br />'))
          }

          for (let i in data.sheets) {
            const sh = data.sheets[i]
            vm.d.push({ f: sh, t: 'reaInfADI', y: this.surveillance.year })
          }
        }
      ),
      validator.steps.validate(vm => vm.d, true),
      baseSteps.purge('reaInfADI'),
      baseSteps.insert('reaInfADI')
    ]

    return {
      show: false,
      iterator: new StepIterator(steps)
    }
  },

  computed: {
    completed: function () {
      return this.iterator.completed
    }
  },

  watch: {
    show: function (value) {
      if (!value) {
        this.iterator.reset()
      }
    }
  },

  methods: {
    importSheets: function () {
      this.iterator.start(this)
      this.show = true
    },

    hide: function () {
      this.show = false
    }
  },

  components: {
    'steps': steps
  }
}
</script>
<style lang="less" scoped>
</style>
